const setDark = () => {
    localStorage.setItem('theme', 'dark');
    document.documentElement.setAttribute('data-theme', 'dark');
}
const setLight = ()=>{
    localStorage.setItem('theme', 'light');
    document.documentElement.setAttribute('data-theme', 'light');
}
const storedTheme = localStorage.getItem('theme');

const prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;

const defaultDark = storedTheme === "dark" || (storedTheme == null && prefersDark);

if(defaultDark){
    setDark();
}
const ChangeTheme = () => {
    return ( 
        <div className="theme-toggler">
            <label className="switch">
                <input 
                id="theme-toggle" 
                type="checkbox"
                onChange={(e)=> (e.target.checked ?  setDark() : setLight())}
                defaultChecked={defaultDark}
                />
                <span className="slider round"></span>
            </label>
            <span id="theme-name" className="theme-togglertext" >Dark Mode</span>
        </div>
     );
}
 
export default ChangeTheme;